import { patchRequest } from '@/core';
import { edi } from '@/requests';

export default async function(edipartId, patch) {
	let url = edi.patchEdipartPath(edipartId);
	await patchRequest(url, '', patch);
}